import { render, staticRenderFns } from "./VueDraggableResizable.vue?vue&type=template&id=21579e02&"
import script from "./VueDraggableResizable.vue?vue&type=script&lang=js&"
export * from "./VueDraggableResizable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21579e02')) {
      api.createRecord('21579e02', component.options)
    } else {
      api.reload('21579e02', component.options)
    }
    module.hot.accept("./VueDraggableResizable.vue?vue&type=template&id=21579e02&", function () {
      api.rerender('21579e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/vue-draggable-resizeable/components/VueDraggableResizable.vue"
export default component.exports